import { createGlobalStyle } from 'styled-components';
import { DropdownProps, useDayPicker } from 'react-day-picker';
import colors from '../../style/colors';
import { actionColor } from '../../style/theme-helpers';
import DeprecatedSelect from '../deprecated-select';
import { Div } from '../box';

export const DatePickerStyles = createGlobalStyle`
  .rdp-root.rdp-root {
    --rdp-accent-color: ${actionColor};
  }

  .rdp-selected .rdp-day_button {
    background-color: var(--rdp-accent-color);
    color: ${colors.white};
  }

  .rdp-range_middle .rdp-day_button {
    background-color: transparent;
    color: inherit;
  }

  .rdp-today:not(.rdp-outside, .rdp-selected) button {
    color: ${colors.black};
    border-color: ${colors.gray300};
  }
`;

export function CustomDropdown(props: DropdownProps & { width?: number }) {
  const { options, value, onChange, width } = props;

  const handleValueChange = (newValue: { value?: string | number; label?: string } | null) => {
    if (onChange) {
      const syntheticEvent = {
        target: {
          value: newValue?.value,
        },
      } as React.ChangeEvent<HTMLSelectElement>;

      onChange(syntheticEvent);
    }
  };

  return (
    <Div width={width}>
      <DeprecatedSelect options={options} value={value} onChange={handleValueChange} />
    </Div>
  );
}

export function CustomMonthDropdown(props: DropdownProps) {
  const { components } = useDayPicker();

  // @ts-expect-error TODO Fix type
  return <components.Dropdown {...props} width={180} />;
}

export function CustomYearsDropdown(props: DropdownProps) {
  const { components } = useDayPicker();

  // @ts-expect-error TODO Fix type
  return <components.Dropdown {...props} width={100} />;
}
